
import React from 'react'
console.log(React)
export default function CheckboxItem(props) {
  return (<div className='CheckboxItem' onClick={() => {
    props.change && props.change(props.id)
  }}>
    <span className={`CheckboxItem_box ${props.active ? 'active' : ''}`}></span>
    <span className='CheckboxItem_text'>{props.children}</span>
  </div>)
}
